/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';
import { Button, Row, Col, Modal, Table, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import moment from 'moment';
import axios from 'axios';
import * as momentTz from 'moment-timezone'

// project imports
import { MyAccountMenuList } from '../MyAccountMenuList';
import { invoiceDetail, transactionHistory,invoicePrintPdf  } from 'shared/settings/apiconfig';
import store from 'features/store';
import { getBuyersUrl, getBuyerHeaders } from 'shared/http';
import { InvoiceService, LocationService } from 'shared/services';
import { isAuthorized } from 'shared/settings/auth';
//style imports
import './InvoiceView.scss';
import ToasterMessage from 'shared/toast/toast';
import { allWordsInCaps } from 'shared/modifiers';
import { FEE_TYPE_LIST } from 'shared/settings/config';
import { responseCodeAndStatus } from './DeclinedCardStatus';
import { getItemUrl } from 'shared/utils/utils';
import { Loader } from 'shared/hoc/loader/Loader';
 

/**


@Author Narmadha

@param

@return html code for invoice view

**/

class InvoiceView extends Component {
    status = { 'paid': 'fa-check-circle', 'unpaid': 'fa-times-circle' };
    address = ['city', 'state', 'country', 'zipcode'];
    pdfRef;
    a;
    url;
    blob;
    logoImage;
    image64;
    amountduePosition;
    invoiceTotalPosition;

    constructor(props) {
        super(props);
        this.toasterMessage = createRef();
        this.state = {
            pageLoading: false,
            windowWidth: window.innerWidth,
            transactionModal: false,
            transactionData: [],
            invoiceview: 0,
            mirstatus: this.props?.location?.state?.mirstatus,
            dgstatus: this.props?.location?.state?.dgstatus,
            shippeditem: this.props?.location?.state?.shippeditem,
            form: {
                id: Number(this.props.match.params.invoiceId),
                billingto: {
                    name: '',
                    address1: '',
                    address2: '',
                    city: '',
                    state: '',
                    country: '',
                    zipcode: '',
                    cityState: '',
                    countryZipcode: '',
                    email: '',
                    phonenumber: ''
                },
                billingfrom: {
                    contactname: '',
                    address1: '',
                    address2: '',
                    city: '',
                    state: '',
                    country: '',
                    zipcode: '',
                    cityState: '',
                    countryZipcode: '',
                    contactemail: '',
                    contactmobile: ''
                },
                shippingto: {
                    address: '',
                    cityState: '',
                    countryZipcode: '',
                    showShippingAddress: false
                },
                childinvoiceid: '',
                childinvoicedate: '',
                items: [],
                total: '',
                buyerspremium: '',
                child_invoice: [],
                masterId: "",
                masterinvoicenumber: "",
                selectedService: "",
                tax: '',
                grossamount: '',
                amountdue: '',
                status: '',
                childInvoiceStatus: '',
                childUnpaidInvoiceId: '',
                invoicenumber: '',
                applytaxonbp: '',
                createddate: '',
                timezone: '',
                totaltax: '',
                totaltaxamount: '',
                totalbp: '',
                totalbpamount: '',
                taxonBPamount: '',
                totalgrossamount: '',
                additionalnotes: '',
                invoicemessage: '',
                totalInvoiceAmount : '' ,
                totalInvoicePendingAmount : '' ,
                invoiceStatusAll : '' ,
                autoDebitStatus : ''
            },
            downloadPdf: false,
            printPdf: false,
            locationDetails: {},
            noDataFound: false,
            saletitle: null,
            saleid: null,
            checkingCheckout: false,
            serverURL: "",
            DisplayTrackingid: "",
            pendingAmount: "",
            invoiceitemreceiptmethod: "",
            totalInvoiceAmount : 0,
            totalInvoicePendingAmount : 0,
            totalInvoiceAmountPaid : 0,
            bidderAcceptanceModal: false,
            bidderAcceptanceData: '',
            bidderAcceptanceInvoiceIds: [],
            bidderAcceptanceAddOn: '',
            confirmApprove : false,
            checkapprove: false,
        }
        this.pdfRef = createRef();
        this.image64 = '';
        this.amountduePosition = '';
        this.paymentButtonImage64 = '';
        this.circleCheckImage = '';
        this.circleCrossImage = '';
    }

    componentDidMount() {
        this.getServerUrl();
        window.addEventListener('resize', this.updateDimensions);
        store.dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: MyAccountMenuList(), withSpan: false } });
        store.dispatch({ type: 'SET_SIDEBAR', payload: false });
        if (isAuthorized()) {
            this.getInvoiceData();
        } else {
            store.dispatch({ type: 'SET_EXTRA_Z_INDEX', payload: true });
            store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
        }
        store.dispatch({ type: 'TOGGLE_SIDEBAR', payload: true });
    }
    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
            this.getInvoiceData();
            // this.getTransactionData();
            store.dispatch({ type: 'SET_EXTRA_Z_INDEX', payload: false });
        }
    }
    printPdf(values) {

        if (values == 'download') {
            this.setState({
                downloadPdf: true
            })
        }
        else if(values == 'print'){
            this.setState({
                printPdf: true
            })
        }

        let child_invoice = this.state.form.child_invoice[0]?.id ? this.state.form.child_invoice[0]?.id : '';
        let parent_invoce = this.state.form.id
        let invoiceId = child_invoice ? [parent_invoce, child_invoice] : [parent_invoce]
        const data = {
            "saleid": this.state.saleid,
            "invoiceid": invoiceId,
            "type": "print"
        }
        let config = getBuyerHeaders()
        config['responseType'] = 'blob';
        axios.post(getBuyersUrl(invoicePrintPdf), JSON.stringify({ data }), config).then((response) => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const fileURL = window.URL.createObjectURL(blob);

            if (values === 'print') {
                window.open(fileURL, '_blank');
                this.setState({ printPdf: false})
            }

            if (values === 'download') {
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'Download.pdf';
                alink.click();
                this.setState({ downloadPdf: false})
            }
        })
    }

    getServerUrl = () => {
        const absoluteURL = window.location.href;
        const path = this.props.location.pathname;
        const check = absoluteURL.split(path)[0];
        this.setState({
            serverURL: check
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        store.dispatch({ type: 'SET_SIDEBAR', payload: false });
        store.dispatch({ type: 'SET_EXTRA_Z_INDEX', payload: false });

        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    /* Detect window width */
    updateDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    /* Get invoice data of the buyer */
    getInvoiceData = () => {
        this.setState({ pageLoading: true });
        axios.get(getBuyersUrl(`${invoiceDetail}/${Number(this.state.form.id)}`), getBuyerHeaders())
            .then(async response => {
                if (response.data.status === 'success') {
                    if (response.data.data.length) {
                        let invoiceData = response.data.data[0];
                        this.setState({
                            invoiceview : invoiceData.invoiceview
                        })
                        if(invoiceData.masterinvoiceid && (invoiceData.invoicestatus).toLowerCase() != "void"){
                            this.setState({
                                ...this.state.form,
                                form: {
                                    id: invoiceData.masterinvoiceid,
                                    totalInvoiceAmount : 0,
                                    totalInvoicePendingAmount : 0,
                                    totalInvoiceAmountPaid : 0,
                                }
                            })
                            await this.getInvoiceData()
                        } else {
                            this.getTransactionData();
                            let data = JSON.parse(response.data.data[0].details);
                            let selectedService = [];
                            FEE_TYPE_LIST.map((item) => {
                                if (data[item.key]) {
                                    selectedService.push({
                                        ...item,
                                        amount: data[item.key],
                                        remark: data[`${item.key}remark`],
                                    })
                                }
                                return item
                            });

                            if(typeof invoiceData.createdtype === "string" && invoiceData.createdtype.toLowerCase() == "manual" && typeof invoiceData.bidderacceptance === "string" && invoiceData.bidderacceptance.toLowerCase() == "not accepted" && invoiceData.invoicestatus.toLowerCase() == "unpaid"){
                                if(!this.state.bidderAcceptanceInvoiceIds.includes(invoiceData.id)){
                                    this.state.bidderAcceptanceInvoiceIds.push(invoiceData.id)
                                }
                            }

                            let child_invoice = invoiceData["child_invoice"] ? invoiceData["child_invoice"] : []
                            child_invoice = child_invoice.map((item) => {
                                if(typeof item.createdtype === "string" && item.createdtype.toLowerCase() == "manual" && typeof item.bidderacceptance === "string" && item.bidderacceptance.toLowerCase() == "not accepted" && item.invoicestatus.toLowerCase() === "unpaid"){
                                    if(!this.state.bidderAcceptanceInvoiceIds.includes(item.id)){
                                        this.state.bidderAcceptanceInvoiceIds.push(item.id)
                                    }
                                }
                                this.state.form.totalInvoiceAmount = Number(this.state.form.totalInvoiceAmount) + Number(item.invoiceamount);
                                this.state.form.totalInvoicePendingAmount = Number(this.state.form.totalInvoicePendingAmount) + Number(item.pendingamount);
                                this.state.form.childInvoiceStatus = item.invoicestatus.toLowerCase() == "paid" ? "paid" : "unpaid";
                                this.state.form.childUnpaidInvoiceId = item.invoicestatus.toLowerCase() == "unpaid" ? item.id : "";
                                let child_invoice_details = JSON.parse(item.details)
                                child_invoice_details["billingto"] = {
                                    name: child_invoice_details["billingto"]["firstname"],
                                    address1: child_invoice_details["billingto"]["address1"],
                                    cityState: (`${child_invoice_details["billingto"]["city"] ? child_invoice_details["billingto"]["city"] : ""} ${child_invoice_details["billingto"]["state"] ? child_invoice_details["billingto"]["state"] : ""}`),
                                    countryZipcode: (`${child_invoice_details["billingto"]["country"] ? child_invoice_details["billingto"]["country"] : ""} ${child_invoice_details["billingto"]["zipcode"] ? child_invoice_details["billingto"]["zipcode"] : ""}`),
                                    email: child_invoice_details["billingto"]["email"],
                                    phonenumber: child_invoice_details["billingto"]["mobile"],
                                }
                                child_invoice_details["billingfrom"] = {
                                    contactname: child_invoice_details["billingfrom"]["contactname"],
                                    address1: child_invoice_details["billingfrom"]["address1"],
                                    cityState: (`${child_invoice_details["billingfrom"]["city"] ? child_invoice_details["billingfrom"]["city"] : ""} ${child_invoice_details["billingfrom"]["state"] ? child_invoice_details["billingfrom"]["state"] : ""}`),
                                    countryZipcode: (`${child_invoice_details["billingfrom"]["country"] ? child_invoice_details["billingfrom"]["country"] : ""} ${child_invoice_details["billingfrom"]["zipcode"] ? child_invoice_details["billingfrom"]["zipcode"] : ""}`),
                                    contactemail: child_invoice_details["billingfrom"]["contactemail"],
                                    contactmobile: child_invoice_details["billingfrom"]["contactmobile"],
                                }
                                let child_invoice_selectedService = []
                                FEE_TYPE_LIST.map((item) => {
                                    if (child_invoice_details[item.key]) {
                                        child_invoice_selectedService.push({
                                            ...item,
                                            amount: child_invoice_details[item.key],
                                            remark: child_invoice_details[`${item.key}remark`],
                                        })
                                    }
                                    return item
                                })
                                return ({
                                    ...item,
                                    details: child_invoice_details,
                                    selectedService: child_invoice_selectedService,
                                })
                            })
                            this.setState({
                                form: {
                                    ...this.state.form,
                                    child_invoice: child_invoice,
                                    masterId: invoiceData.masterinvoiceid ? invoiceData.masterinvoiceid : "",
                                    masterinvoicenumber: invoiceData.masterinvoicenumber ? invoiceData.masterinvoicenumber : "---",
                                    selectedService,
                                }
                            }, () => {
                                const locationDetailData = { "sort": [{ "field": "title", "direction": "asc" }] };
                                LocationService.getLocationDetails(invoiceData.locationid, locationDetailData).then(
                                    locationResponse => {
                                        let billingfromCityDelimiter = data.billingfrom.city && data.billingfrom.state ? ', ' : '';
                                        let billingfromCountryDelimiter = data.billingfrom.country && data.billingfrom.zipcode ? ', ' : '';
                                        let billingtoCityDelimiter = data.billingto.city && data.billingto.state ? ', ' : '';
                                        let billingtoCountryDelimiter = data.billingto.country && data.billingto.zipcode ? ', ' : '';
                                        let shippingtoCityDelimiter = data.billingfrom.city && data.billingfrom.state ? ', ' : '';
                                        let shippingtoCountryDelimiter = data.billingfrom.country && data.billingfrom.zipcode ? ', ' : '';
                                        this.setState({
                                            DisplayTrackingid: invoiceData.trackshippingid ? invoiceData.trackshippingid : '',
                                            form: {
                                                ...this.state.form,
                                                autoDebitStatus: invoiceData.autoDebitStatus,
                                                billingto: {
                                                    ...this.state.form.billingto,
                                                    name: data.billingto.firstname + ' ' + data.billingto.lastname,
                                                    address1: (data.billingto.address1 ? data.billingto.address1 + ', ' : '') + (data.billingto.address2 ? data.billingto.address2 + ', ' : ''),
                                                    city: data.billingto.city,
                                                    state: data.billingto.state,
                                                    country: data.billingto.country,
                                                    zipcode: data.billingto.zipcode,
                                                    cityState: (data.billingto.city ? data.billingto.city : '') + (billingtoCityDelimiter) + (data.billingto.state ? data.billingto.state : ''),
                                                    countryZipcode: (data.billingto.country ? data.billingto.country : '') + (billingtoCountryDelimiter) + (data.billingto.zipcode ? data.billingto.zipcode : ''),
                                                    email: data.billingto.contactemail ? data.billingto.contactemail : data.billingto.email ? data.billingto.email : '',
                                                    phonenumber: data.billingto.contactmobile ? data.billingto.contactmobile : data.billingto.mobile ? data.billingto.mobile : '',
                                                },
                                                billingfrom: {
                                                    ...this.state.form.billingfrom,
                                                    contactname: data.billingfrom.contactname,
                                                    address1: (data.billingfrom.address1 ? data.billingfrom.address1 + ', ' : '') + (data.billingfrom.address2 ? data.billingfrom.address2 + ', ' : ''),
                                                    city: data.billingfrom.city,
                                                    state: data.billingfrom.state,
                                                    country: data.billingfrom.country,
                                                    zipcode: data.billingfrom.zipcode,
                                                    cityState: (data.billingfrom.city ? data.billingfrom.city : '') + (billingfromCityDelimiter) + (data.billingfrom.state ? data.billingfrom.state : ''),
                                                    countryZipcode: (data.billingfrom.country ? data.billingfrom.country : '') + (billingfromCountryDelimiter) + (data.billingfrom.zipcode ? data.billingfrom.zipcode : ''),
                                                    contactemail: data.billingfrom.contactemail ? data.billingfrom.contactemail : data.billingfrom.email ? data.billingfrom.email : '',
                                                    contactmobile: data.billingfrom.contactmobile ? data.billingfrom.contactmobile : data.billingfrom.mobile ? data.billingfrom.mobile : '',
                                                },
                                                shippingto: {
                                                    ...this.state.form.shippingto,
                                                    address: (data?.shippingto?.address1 ? data?.shippingto?.address1 + ', ' : '') + (data?.shippingto?.address2 ? data?.shippingto?.address2 + ', ' : ''),
                                                    cityState: (data?.shippingto?.city ? data?.shippingto?.city : '') + (shippingtoCityDelimiter) + (data?.shippingto?.state ? data?.shippingto?.state : ''),
                                                    countryZipcode: (data?.shippingto?.country ? data?.shippingto?.country : '') + (shippingtoCountryDelimiter) + (data?.shippingto?.zipcode ? data?.shippingto?.zipcode : ''),
                                                    showShippingAddress: data?.shippingto ? true : false
                                                },
                                                childinvoiceid: invoiceData.childinvoiceid ? invoiceData.childinvoiceid : '',
                                                childinvoicedate: invoiceData.childinvoicedate ? invoiceData.childinvoicedate : '',
                                                items: data.items,
                                                total: data.invoiceamount ? data.invoiceamount : data.totalamount ? data.totalamount : '',
                                                buyerspremium: data.buyerspremium,
                                                tax: data.tax,
                                                grossamount: data.grossamount,
                                                amountdue: data.amountdue ? data.amountdue : invoiceData.invoiceamount,
                                                status: invoiceData.invoicestatus,
                                                invoicenumber: invoiceData.invoicenumber,
                                                applytaxonbp: invoiceData.applytaxonbp,
                                                createddate: invoiceData.createddate,
                                                timezone: invoiceData.timezonename,
                                                additionalnotes: invoiceData.additionalnotes ? invoiceData.additionalnotes : '',
                                                invoicemessage: data.invoicemessage ? JSON.parse(data.invoicemessage).content.body : '',
                                                totalInvoiceAmount : invoiceData.invoiceamount ? (Number(this.state.form.totalInvoiceAmount) + Number(invoiceData.invoiceamount)) : Number(this.state.form.totalInvoiceAmount),
                                                totalInvoiceAmountPaid : this.calculatePaymentReceived(invoiceData.invoiceamount, invoiceData.pendingamount),
                                                totalInvoicePendingAmount : invoiceData.pendingamount ? (Number(this.state.form.totalInvoicePendingAmount) + Number(invoiceData.pendingamount)) : Number(this.state.form.totalInvoicePendingAmount),
                                            },
                                            pageLoading: false,
                                            locationDetails: locationResponse.data.data,
                                            saletitle: invoiceData.saletitle,
                                            saleid: invoiceData.saleid,
                                            pendingAmount: invoiceData.pendingamount ? invoiceData.pendingamount : 0,
                                            invoiceitemreceiptmethod: invoiceData.invoiceitemreceiptmethod
                                        }, () => this.calculateTotal());
                                    }
                                ).catch(error => {
                                    this.setState({ pageLoading: false, noDataFound: true });
                                });
                            })
                        }
                    } else {
                            this.setState({ noDataFound: true, pageLoading: false })
                        }
                    }
            })
            .catch(error => {
                this.setState({ pageLoading: false, noDataFound: true });
            });
    }

    // get payment received
    calculatePaymentReceived = (invoiceAmount, pendingAmount) => {
        let totalInvoiceAmt = Number(this.state.form.totalInvoiceAmount)
        let totalPendingAmt = Number(this.state.form.totalInvoicePendingAmount)
        if(invoiceAmount) {
            totalInvoiceAmt += Number(invoiceAmount)
        }
        if(pendingAmount) {
            totalPendingAmt += Number(pendingAmount)
        }
        return totalInvoiceAmt - totalPendingAmt
    }

    /* calculate total for invoice amount, tax, buyerspremium */
    calculateTotal = () => {
        let amountTotal = 0;
        let taxTotal = 0;
        let taxamountTotal = 0;
        let buyerspremiumTotal = 0;
        let buyerspremiumamountTotal = 0;
        let taxonbuyerspremiumTotal = 0;
        let grossamountTotal = 0;
        this.state.form.items.forEach(item => {
            amountTotal = amountTotal + parseFloat(item.amount);
            taxTotal = taxTotal + parseFloat(item.tax);
            taxamountTotal = taxamountTotal + parseFloat(item.taxamount);
            buyerspremiumTotal = buyerspremiumTotal + parseFloat(item.buyerspremium);
            buyerspremiumamountTotal = buyerspremiumamountTotal + parseFloat(item.buyerspremiumamount);
            taxonbuyerspremiumTotal = taxonbuyerspremiumTotal + parseFloat(item.taxonBPamount);
            grossamountTotal = grossamountTotal + parseFloat(item.grossamount);
        });

        this.setState({
            form: {
                ...this.state.form,
                totaltax: taxTotal ? taxTotal : 0,
                totaltaxamount: taxamountTotal ? taxamountTotal : 0,
                totalbp: buyerspremiumTotal ? buyerspremiumTotal : 0,
                totalbpamount: buyerspremiumamountTotal ? buyerspremiumamountTotal : 0,
                totaltaxonbpamount: this.state.form.applytaxonbp ? (taxonbuyerspremiumTotal ? taxonbuyerspremiumTotal : 0) : 0,
                totalgrossamount: grossamountTotal ? grossamountTotal : 0,
                totalamount: amountTotal ? amountTotal : 0
            }
        });
    }

    /* Get transaction history data */
    getTransactionData = () => {
        const data = {
            filter: [
                { field: 'invoiceid', value: Number(this.state.form.id), op: '=', join: 'AND' }
            ]
        };
        this.setState({ pageLoading: true });

        axios.post(getBuyersUrl(transactionHistory), JSON.stringify(data), getBuyerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({ transactionData: response.data.data });
                }
            })
            .catch(error => {
                this.setState({ pageLoading: false });
            })
    }

 
 
    navigateToCorrectPath = () => {
        const { mirstatus, dgstatus, shippeditem } = this.state;
        const { history } = this.props;
    
        if (mirstatus) {
          history.push({pathname : `/my-account/mir`, state: this.props?.location?.state});
        } else if (dgstatus) {
          history.push({pathname : `/my-account/gd`,  state: this.props?.location?.state});
        } else if (shippeditem) {
          history.push({pathname : `/my-account/invoice/shipped-items`,  state: this.props?.location?.state});
        } else {
          history.push({pathname : `/my-account/invoice`, state: this.props?.location?.state});
        }
      };

   

    /* Format amount*/
    formatCurrency(amount) {
        if (amount || amount === 0) {
            return "$ " + parseFloat(amount).toFixed(2);
        }
        else
            return '- - -';
    }

    /* Format amount to percent*/
    formatPercent(amount) {
        if (amount || amount === 0)
            return (amount) + "%";
        else
            return '';
    }

    /* Date format for invoice generation */
    formatDate(date) {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        return year + "/" + month + "/" + day;
    }

    /* covert html string to text */
    convertHTMlToText = (text) => {
        let invoicemessage = text.replace(/<style([\s\S]*?)<\/style>/gi, '');
        invoicemessage = invoicemessage.replace(/<script([\s\S]*?)<\/script>/gi, '');
        invoicemessage = invoicemessage.replace(/<\/div>/ig, '\n');
        invoicemessage = invoicemessage.replace(/<\/li>/ig, '\n');
        invoicemessage = invoicemessage.replace(/<li>/ig, '  *  ');
        invoicemessage = invoicemessage.replace(/<\/ul>/ig, '\n');
        invoicemessage = invoicemessage.replace(/<\/p>/ig, '\n');
        invoicemessage = invoicemessage.replace(/<br\s*[/]?>/gi, "\n");
        invoicemessage = invoicemessage.replace(/<[^>]+>/ig, '');
        invoicemessage = invoicemessage.replace(/&nbsp/ig, ' ');
        return invoicemessage;
    }

    /*Print invoice when clicked print */
    print = () => {
        const printableElements = document.getElementById('invoiceGenration').innerHTML;
        const orderHtml = '<html><head><title></title></head><body>' + printableElements + '</body></html>';
        // const oldPage = document.body.innerHTML;
        document.body.innerHTML = orderHtml;
        window.print();
        window.location.reload(true);
    }

    /* Paypal payment */
    payPalPayment = () => {
        if (this.state.form.amountdue) {
            this.setState({
                checkingCheckout: true
            }, () => {
                InvoiceService.getInvoiceDetail(this.state.form.id).then(
                    res => {
                        const result = res.data.data[0];
                        if (result.invoicestatus === "Unpaid") {
                            store.dispatch({
                                type: 'PAYPAL_PAYMENT_PAGE',
                                payload: {
                                    amount: parseFloat(this.state.pendingAmount).toFixed(2),
                                    redirectTo: `/my-account/invoice`,
                                    moreDetails: {
                                        payee: this.state.locationDetails[0].paypalemail,
                                        invoicenumber: this.state.form.id,
                                        description: `Invoicenumber - ${this.state.form.invoicenumber}, Sale id - ${this.state.saleid}`,
                                        reference_id: `invoicenumber - ${this.state.form.invoicenumber}`
                                    }
                                }
                            });
                            this.props.history.push('/payment');
                        } else {
                            this.setState({
                                checkingCheckout: false
                            });
                            this.toasterMessage.current.showMessage({ type: 'danger', message: "Invoice already paid" });
                        }
                    }
                ).catch(error => {
                    this.toasterMessage.current.showMessage({ type: 'danger', message: error.message });
                    this.setState({
                        checkingCheckout: false
                    });
                });
            });
        }
    }

    viewItem = (e, item) => {
        e.preventDefault();
        this.props.history.push(getItemUrl(this.state.saleid, item.id, item.itemseourl));
    }

    getTransactionMessage = (data) => {
        try {
            if(data) {
                let parsedData = JSON.parse(data)
                parsedData = ("data" in parsedData && parsedData?.data ) ? parsedData.data: parsedData
                let responseCode = parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.processor_response ? parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.processor_response?.response_code : parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status
                let message = responseCode?.toLowerCase() == "completed" ? 'Payment approved and completed' : parsedData?.name == 'UNPROCESSABLE_ENTITY' ? parsedData.details?.[0]?.issue : parsedData.name == "INTERNAL_SERVER_ERROR" ? 'PayPal Payment Gateway currently unavailable: This payment could not be processed at this time. Please try again later.' : parsedData?.message ? parsedData.message : responseCode ? `${responseCode} - ${responseCodeAndStatus?.[responseCode]}` :'Please contact CTBIDS help desk'
                return message ? message : "---"
            }
        } catch (err) {
            //handle err
        }
        return '';
    }
    
    captializeLetter = (data) => {
        const capitalized = data.charAt(0).toUpperCase() + data.slice(1);
        return capitalized;
    }

    bidderAcceptance = (bidAccept, bidAddOn) => {
        let isAddOn = false;
        if ( this.state.bidderAcceptanceInvoiceIds[0] == this.state.form.id ) {
            isAddOn = false;
        } else {
            let filteredData = this.state.form.child_invoice.filter(elem => { return this.state.bidderAcceptanceInvoiceIds[0] == elem['id']; });
            isAddOn = filteredData.length > 0 ? true : false;
        }
        this.setState({
            checkapprove: true
        })
        
        InvoiceService.bidderAccept(this.state.bidderAcceptanceInvoiceIds[0], {data: {"bidderacceptance": bidAccept, "isaddon": isAddOn}}).then(
            response => {
                if (response.data.status.toLowerCase() == "success") {
                    let pendingBidderAcceptance = this.state.bidderAcceptanceInvoiceIds;
                    pendingBidderAcceptance.splice(0, 1);
                    this.setState({
                        confirmApprove: true,
                        checkapprove: false,
                        bidderAcceptanceInvoiceIds: pendingBidderAcceptance,
                    },()=>{
                        setTimeout(() => {
                            this.setState({
                                bidderAcceptanceModal: false,
                                confirmApprove: false
                            })
                            
                        }, 3000);
                    })
                }
            }
        ).catch(error => {
            this.setState({
                confirmApprove: false,
                checkapprove: false
            })
        });
    }

    showBidderAcceptanceModal = (data, addOn) =>{
        this.setState({
            bidderAcceptanceModal: true,
            bidderAcceptanceData: data,
            bidderAcceptanceAddOn: addOn
        })
    }

    closeConfirmModal = () => {
        this.setState({
            bidderAcceptanceModal: false,
            bidderAcceptanceData: '',
            bidderAcceptanceAddOn: ''
        })
    }

    render() {
        return (
            <div className={`invoice-view-main ${isAuthorized() ? '' : 'disable-page'}`}>
                {
                    !isAuthorized() ? <div className="un-auth-page d-flex align-items-center justify-content-center">
                        <div className={`h2 text-center ${this.props.toggleSignInModal?.open ? 'reduce-pad' : ''}`}>
                            Kindly login to view <br></br> the invoice
                        </div>
                    </div> : null
                }
                {
                    this.state.pageLoading ?
                       <Loader /> :
                        !this.state.noDataFound ?
                            <div className="main-content mt-3 container">
                                <div className="d-flex">
                                    <div className=" w-50 justify-content-start text-left mt-3">
                                        <Button style={{ backgroundColor: '#A50050' }} onClick={() => this.navigateToCorrectPath()} className="m-1"><i className="fa fa-chevron-left pr-2"></i>Back</Button>
                                        <Button onClick={() => this.setState({ transactionModal: true })} className="transactionButton m-1">Transaction History</Button>
                                    </div>
                                    <div className=" w-50 d-flex justify-content-end align-items-baseline text-right mt-3">
                                        <ToasterMessage className="alert-handle" ref={this.toasterMessage}></ToasterMessage>
                                        {/* <Button variant="success" className="m-1" onClick={() => this.payPalPayment()}
                                            disabled={this.state.form.status.toLowerCase() !== 'unpaid' || this.state.checkingCheckout || this.state.pendingAmount <= 0}>
                                            Checkout {this.state.checkingCheckout ? <Spinner animation="border" as="span" size="sm" role="status" aria-hidden="true"></Spinner> : null}
                                        </Button> */}
                                        <Button variant="dark" className="m-1" disabled={this.state.printPdf} onClick={() => this.printPdf('download')}>Download  {this.state.downloadPdf ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null} </Button>
                                        <Button variant="secondary" className="m-1 printBackground" onClick={() =>this.printPdf('print') } disabled={this.state.downloadPdf} >Print {this.state.printPdf ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                    </div>
                                </div>
                                <div className="invoiceBorder mt-3 mb-4">
                                    <div id="invoiceGenration" className="print" ref={this.pdfRef} >
                                        <div className="p-4 border-bottom row mx-0">
                                            <div className={` ${this.state.windowWidth > 800  ? 'd-flex text-left wd-30' : 'd-flex text-left wd-50'}`}>
                                                <img className={` ${this.state.windowWidth > 800 ? 'pdf-img' : 'pdf-img-800'}`} src={`${process.env.PUBLIC_URL}/static/logo/CTBids_logo.png`} alt="logo" />
                                                {/* {this.state.form.status.toLowerCase() === 'paid' && <span className="text-success"><i className={`fa ${this.status[this.state.form.status.toLowerCase()]} fa-lg pr-2 pt-1`} aria-hidden="true"></i>{this.state.form.status.toUpperCase()}</span>} */}
                                            </div>
                                            <div >
                                                {this.state.form.autoDebitStatus === "Not Available" ?
                                                    <div className={` text-secondary col-xs-12`} style={{ width: '80%', textAlign: 'center'}}><div>Our process has changed, please reach out to the Seller to coordinate payment </div></div> : ""
                                                }
                                            </div>
                                            { this.state.bidderAcceptanceInvoiceIds.length > 0 ? <div style={{textAlign: "center"}}>
                                                <div style={{display: "flex", justifyContent: 'center'}}>
                                                    <Button className="m-1" onClick={()=>this.showBidderAcceptanceModal("Accepted", true)} style={{color: "white", backgroundColor: "green"}}>Approve</Button>
                                                    <Button className="m-1 printBackground" onClick={()=>this.showBidderAcceptanceModal("Declined", false)} style={{color: "white", backgroundColor: "#D22B2B"}}>Decline</Button>
                                                </div>
                                                { this.state.form.child_invoice.length !== 0 ? <div>Pending Approval of Additional Services</div> : <div>Approval Pending</div> }
                                            </div> : '' }
                                            { this.state.bidderAcceptanceInvoiceIds.length > 0 ? <div style={{width: '35%', float: "right"}}>
                                                <p><b>Please notes: </b> Your payment method on file will be charged the Additional Services amount after selecting Approve. Please contact seller for any questions.</p>
                                            </div> : ''}
                                            <div className={`${this.state.windowWidth > 800 ? 'justify-content-end mt-3' : 'justify-content-center text-center mt-1'}`} style={{ fontSize: "20px", textAlign: "right", width: '65%'}}>
                                                {/* <div className={` text-secondary col-xs-12`}><div style={{ fontSize: "20px" }}>Invoice: {this.state.form.invoicenumber}</div></div> */}
                                                {this.state.DisplayTrackingid ?
                                                    <div className={` text-secondary col-xs-12`}><div>Tracking Id: {this.state.DisplayTrackingid ? this.state.DisplayTrackingid : "  - - -"}</div></div> : ""
                                                }
                                                {this.state.invoiceitemreceiptmethod && this.state.invoiceview ?  <span className="h4">Item Receipt Method: {allWordsInCaps(this.state.invoiceitemreceiptmethod)}</span> : null}
                                            </div>
                                        </div>
                                        <div className="d-flex row p-4 border-bottom mx-0">
                                            <div className={`col col-xs-12 padding ${this.state.form.shippingto.showShippingAddress ? 'col-md-4' : 'col-md-6'}`}>
                                                <p><b className="text-secondary"> Billing To</b></p>
                                                {Object.keys(this.state.form.billingto).map((key) =>
                                                    !this.address.includes(key) ?
                                                        key === 'name' ? <p><b>{this.state.form.billingto[key]}</b></p> :
                                                            key === 'phonenumber' ? this.state.form.billingto[key] ? <p style={{ color: "#1d9aa5" }} >Phone No: {this.state.form.billingto[key]}</p> : '' :
                                                                key === 'email' ? <p style={{ color: "#1d9aa5", wordBreak: 'break-all' }} >{this.state.form.billingto[key]}</p> : <p style={{ wordBreak: 'break-all' }}>{this.state.form.billingto[key]}</p> : ''
                                                )}
                                            </div>
                                            <div className={`col col-xs-12 padding ${this.state.form.shippingto.showShippingAddress ? 'col-md-4' : 'col-md-6'}`}>
                                                <p><b className="text-secondary">Pickup Location</b></p>
                                                {Object.keys(this.state.form.billingfrom).map((key) =>
                                                    !this.address.includes(key) ?
                                                        key === 'contactname' ? <p><b>{this.state.form.billingfrom[key]}</b></p> :
                                                            key === 'contactmobile' ? this.state.form.billingfrom[key] ? <p style={{ color: "#1d9aa5" }}>Phone No: {this.state.form.billingfrom[key]}</p> : '' :
                                                                key === 'contactemail' ? <p style={{ color: "#1d9aa5" }}>{this.state.form.billingfrom.contactemail} </p> : <p>{this.state.form.billingfrom[key]}</p> : ''
                                                )}
                                            </div>
                                            {this.state.form.shippingto.showShippingAddress ? <div className="col col-md-4 col-xs-12 padding">
                                                <p><b className="text-secondary">Shipping To</b></p>
                                                {Object.keys(this.state.form.shippingto).map((key) =>
                                                    !this.address.includes(key) ? <p style={{  wordBreak: 'break-all' }}>{this.state.form.shippingto[key]}</p> : ''
                                                )}
                                            </div> : ''}
                                            {/* { this.state.form.childinvoiceid ? 
                                                <div className="col col-md-4 col-xs-12 padding">
                                                    <b className="text-secondary">Child Invoice</b> :
                                                    <p><b>{this.state.form.childinvoiceid }</b></p>
                                                    <p>{moment(this.state.form.childinvoicedate).format('MMM DD YYYY')}</p>
                                                </div>
                                                : '' 
                                            }     */}
                                        </div>
                                        <div className='border-bottom'>
                                            <div className={` p-4 border-bottom mx-0`}>
                                                <div style={{ fontSize: "20px" }}><p><b className="text-secondary">Invoice Details</b></p></div>
                                            </div>
                                            <div className={`${this.state.windowWidth > 800 && "d-flex row"} p-4  mx-0`} style={{ display: 'flex' }}>
                                                <div className="col col-md-6 col-xs-12 padding"><div >
                                                    <p className={` text-secondary col-xs-12`} ><b style={{ fontSize: "20px" }}>Invoice: {this.state.form.invoicenumber}    </b>
                                                    {<span className={`${this.state.form.status.toLowerCase() === 'paid' ? "text-success" : "text-danger"}`}>
                                                        <i className={`fa ${this.status[this.state.form.status.toLowerCase()]} fa-lg pr-2 pt-1`} aria-hidden="true" style={{marginRight:'5px'}}></i>{this.state.form.status.toUpperCase()}</span>}</p></div>
                                                </div>
                                                <div className="col col-md-6 col-xs-12 padding" style={{ textAlign: "right" }}>
                                                    <p><b className="text-secondary">Invoice Date :- </b> 
                                                    <b>{moment.utc(this.state.form.createddate).local().format('MM/DD/YYYY hh:mm A')} {moment.tz(moment.tz.guess()).zoneAbbr()}</b>
                                                    </p>
                                                </div>
                                            </div>
                                            { this.state.form.masterId == '' ? <div style={{ overflowX: "auto" }}>
                                                <Table className="amountfields" responsive>
                                                    <thead>
                                                        <tr style={{ color: "#9F2241", flexWrap: "nowrap" }}>
                                                            <td style={{ paddingLeft: "2.5rem" }}>Items</td>
                                                            <td>SKU</td>
                                                           {!this.state.invoiceview  ?  <td>IRM</td> : null}
                                                            <td>Amount</td>
                                                            <td>Tax</td>
                                                            <td>Tax Amount</td>
                                                            <td>BP</td>
                                                            <td>BP Amount</td>
                                                            {this.state.form.applytaxonbp ? <td>BP Tax Amount</td> : ''}
                                                            <td style={{ paddingRight: "2.5rem" }}>Gross Amount</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.form.items.map((item, index) => (
                                                                <tr>
                                                                    <td style={{ paddingLeft: "2.5rem" }} width="25%">
                                                                        <a className='invoice-link-color' href={getItemUrl(this.state.saleid, item.id, item.itemseourl)} onClick={(event) => this.viewItem(event, item)}>
                                                                            {item.title}
                                                                        </a>
                                                                    </td>
                                                                    <td  width="20%" style={{ wordBreak: "break-word" }} class="id">{item.SKU ? item.SKU : "- - -"}</td>
                                                                    {!this.state.invoiceview  ?  <td  width="5%" style={{ whiteSpace: "nowrap"}} class="id">{item.bidderirm ? this.captializeLetter(item.bidderirm) : '- - -'}</td> : null}
                                                                    <td  width="10%" style={{ whiteSpace: "nowrap" }}>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : '- - -'}</td>
                                                                    <td  width="10%" style={{ whiteSpace: "nowrap" }}>{item.tax ? `${item.tax} %` : '- - -'}</td>
                                                                    <td  width="10%" style={{ whiteSpace: "nowrap" }}>{item.taxamount ? `$ ${parseFloat(item.taxamount).toFixed(2)}` : '- - -'}</td>
                                                                    <td  width="10%" style={{ whiteSpace: "nowrap" }}>{item.buyerspremium ? `${item.buyerspremium} %` : '- - -'}</td>
                                                                    <td  width="10%" style={{ whiteSpace: "nowrap" }}>{item.buyerspremiumamount ? `$ ${parseFloat(item.buyerspremiumamount).toFixed(2)}` : '- - -'}</td>
                                                                    {this.state.form.applytaxonbp ? <td style={{ whiteSpace: "nowrap" }}>{item.taxonBPamount ? `$ ${parseFloat(item.taxonBPamount).toFixed(2)}` : '- - -'}</td> : ''}
                                                                    <td  width="10%" style={{ paddingRight: "2.5rem", whiteSpace: "nowrap" }}>{item.grossamount ? `$ ${parseFloat(item.grossamount).toFixed(2)}` : '- - -'}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                        <tr style={{ fontWeight: "bold", flexWrap: "nowrap" }}>
                                                            <td></td>
                                                            <td></td>
                                                            {!this.state.invoiceview ?  <td></td> : null }
                                                            <td  style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totalamount).toFixed(2)}</td>
                                                            <td></td>
                                                            <td  style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totaltaxamount).toFixed(2)}</td>
                                                            <td></td>   
                                                            <td  style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totalbpamount).toFixed(2)}</td>
                                                            {this.state.form.applytaxonbp ? <td  style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totaltaxonbpamount).toFixed(2)}</td> : ''}
                                                            <td  style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totalgrossamount).toFixed(2)}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div> :  
                                                <div className="serviceview" style={{ padding: ' 0%  5% 0% 5%' }}>
                                                    <div >
                                                        {<Table className="amountfields" responsive style={{ height: "100%" }}>
                                                            <thead>
                                                                <tr style={{ color: "#9F2241", flexWrap: "nowrap" }}>
                                                                    <td>Services</td>
                                                                    <td>Description</td>
                                                                    <td style={{ textAlign: "right", paddingRight: "0px" }}>Amount</td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    this.state.form.selectedService.map((item, index) => (
                                                                        <tr>
                                                                            <td>{item.name}</td>
                                                                            <td>{item.remark ? item.remark : "- - -"}</td>
                                                                            <td style={{ textAlign: "right", paddingRight: "0px" }}>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : '- - -'}</td>
                                                                        </tr>
                                                                    ))
                                                                }

                                                            </tbody>
                                                        </Table>
                                                        }
                                                        <Row className="" >
                                                            <Col></Col>
                                                            <Col className="text-end text-secondary" ><b>Total Amount</b></Col>
                                                            <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b>{this.state.form.total ? `$ ${parseFloat(this.state.form.total).toFixed(2)}` : '- - -'}</b></Col>
                                                        </Row>
                                                    </div>

                                                </div>
                                            }
                                            <div className={`${this.state.windowWidth > 800 ? "d-flex flex-column-reverse" : ""}`} style={{ margin: "2% 5%" }}>
                                                {this.state.form.additionalnotes  ? <p><b className="text-secondary" style={{paddingLeft: "15px"}}> Additional Notes </b>
                                                    <OverlayTrigger className="no-print" trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{this.state.form.additionalnotes}</Tooltip>}>
                                                        <i className={`fa fa-question-circle no-print`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                    
                                                    <div className= { this.state.form.additionalnotes ? 'viewonlyinprint' : ''}>
                                                        {this.state.form.additionalnotes}
                                                    </div>
                                                </p> : ''}
                                                
                                                    {/* <div className="serviceview" >
                                                        <div >
                                                            {this.state.form.selectedService.length > 0 && <Table className="amountfields" responsive style={{ height: "100%" }}>
                                                                <thead>
                                                                    <tr style={{ color: "#9F2241", flexWrap: "nowrap" }}>
                                                                        <td>Services</td>
                                                                        <td>Description</td>
                                                                        <td style={{ textAlign: "right", paddingRight: "0px" }}>Amount</td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        this.state.form.selectedService.map((item, index) => (
                                                                            <tr>
                                                                                <td>{item.name}</td>
                                                                                <td>{item.remark ? item.remark : "- - -"}</td>
                                                                                <td style={{ textAlign: "right", paddingRight: "0px" }}>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : '- - -'}</td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                </tbody>
                                                            </Table>
                                                            }
                                                        </div>
                                                        <Row className="" >
                                                            <Col></Col>
                                                            <Col className="text-right text-secondary" ><b>Total Amount</b></Col>
                                                            <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b>{this.state.form.total ? `$ ${parseFloat(this.state.form.total).toFixed(2)}` : '- - -'}</b></Col>
                                                        </Row>
                                                    </div> */}
                                                { this.state.form.masterId == '' ? <div className="serviceview" >
                                                    {this.state.form.selectedService.length > 0 && this.state.form.selectedService.map((item, index) => (
                                                        <Row className="">
                                                            <Col className="text-left text-secondary" ><b>{item.name}</b></Col>
                                                            <Col>{item.remark}</Col>
                                                            <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : '- - -'}</b></Col>
                                                        </Row>
                                                    ))}

                                                    <Row className="" >
                                                        <Col></Col>
                                                        <Col className="text-end text-secondary" ><b>Total Amount</b></Col>
                                                        <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b>{this.state.form.total ? `$ ${parseFloat(this.state.form.total).toFixed(2)}` : '- - -'}</b></Col>
                                                    </Row>
                                                </div> : ''}
                                            </div>
                                        </div>
                                        <div className={`border-bottom mx-0`}>
                                            {this.state.form.child_invoice &&
                                                this.state.form.child_invoice.map((data, key) => (
                                                    <div className=" h-90 mt-3" >
                                                        <div className="">
                                                            <div className="print" >
                                                                {/* <div className={`d-flex ${this.state.windowWidth > 800 ? "flex-row" : ""} p-4 border-bottom ${this.state.windowWidth > 800 ? '' : 'row'}`}> */}
                                                                    {/* <div className={`${this.state.windowWidth > 800 ? 'justify-content-end text-right w-50 mt-3' : 'justify-content-center text-center mt-1'}  col-md-6`}>
                                                                        <div className={` text-secondary col-xs-12`}><div style={{ fontSize: "20px" }}>Invoice: {data.invoicenumber}</div></div>
                                                                        {this.state.DisplayTrackingid ?
                                                                            <div className={` text-secondary col-xs-12`}><div style={{ fontSize: "20px" }}>Tracking Id: {data.trackshippingid ? data.trackshippingid : "  - - -"}</div></div> : ""
                                                                        }
                                                                        {data.invoicestatus.toLowerCase() === 'paid' && data.invoiceitemreceiptmethod ?
                                                                            <span className="h4">Item Receipt Method: {data.invoiceitemreceiptmethod ? allWordsInCaps(data.invoiceitemreceiptmethod) : "  - - -"}</span> : ""
                                                                        }
                                                                    </div> */}
                                                                {/* </div> */}
                                                                <div className="childInvoice">
                                                                    <div className={`${this.state.windowWidth > 800 && "d-flex row"} p-4  mx-0`} style={{ display: 'flex' }}>
                                                                        <div className="col col-md-6 col-xs-12 padding"><div >
                                                                            <p className={` text-secondary col-xs-12`} ><b style={{ fontSize: "20px" }}>Invoice: {data.invoicenumber} </b>
                                                                            {<span className={`${data.invoicestatus.toLowerCase() === 'paid' ? "text-success" : "text-danger"}`}>
                                                                                <i className={`fa ${this.status[data.invoicestatus.toLowerCase()]} fa-lg pr-2 pt-1`} aria-hidden="true"></i>{data.invoicestatus.toUpperCase()}</span>}</p></div>
                                                                        </div>
                                                                        <div className="col col-md-6 col-xs-12 padding" style={{ textAlign: "right" }}>
                                                                            <p><b className="text-secondary">Invoice Date :- </b> <b>{moment.utc(data.createddate).local().format('MM/DD/YYYY hh:mm A')} {moment.tz(moment.tz.guess()).zoneAbbr()}</b></p>
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className={`${this.state.windowWidth > 800 && "d-flex row"} p-4 mx-0`}> */}
                                                                        {/* <div className="col col-md-4 col-xs-12 padding">
                                                                            <p><b className="text-secondary"> Billing To </b></p>
                                                                            {Object.keys(data.details.billingto).map((key) =>
                                                                                key === 'name' ? <p><b>{data.details.billingto[key]}</b></p> :
                                                                                    key === 'phonenumber' ? data.details.billingto[key] ? <p style={{ color: "#1d9aa5" }}>Phone No: {data.details.billingto[key]}</p> : '' :
                                                                                        key === 'email' ? data.details.billingto[key] ? <p style={{ color: "#1d9aa5" }}>{data.details.billingto[key]}</p> : '' : <p>{data.details.billingto[key]}</p>
                                                                            )}
                                                                        </div>
                                                                        <div className="col col-md-4 col-xs-12 padding">
                                                                            <p><b className="text-secondary">Pickup Location</b></p>
                                                                            {Object.keys(data.details.billingfrom).map((key) =>
                                                                                key === 'contactname' ? <p><b>{data.details.billingfrom[key]}</b></p> :
                                                                                    key === 'contactmobile' ? data.details.billingfrom[key] ? <p style={{ color: "#1d9aa5" }}>Phone No: {data.details.billingfrom[key]}</p> : '' :
                                                                                        key === 'contactemail' ? data.details.billingfrom[key] ? <p style={{ color: "#1d9aa5" }}>{data.details.billingfrom.contactemail} </p> : '' : <p>{data.details.billingfrom[key]}</p>
                                                                            )}
                                                                        </div> */}
                                                                        {/* <div className="col col-md-6 col-xs-12 padding"><div >
                                                                            <p className={` text-secondary col-xs-12`} ><b style={{ fontSize: "20px" }}>Invoice: {data.invoicenumber}</b>
                                                                            {<span className={`${this.state.form.status.toLowerCase() === 'paid' ? "text-success" : "text-danger"}`}>
                                                                                <i className={`fa ${this.status[this.state.form.status.toLowerCase()]} fa-lg pr-2 pt-1`} aria-hidden="true"></i>{this.state.form.status.toUpperCase()}</span>}</p></div>
                                                                        </div>
                                                                        <div className="col col-md-6 col-xs-12 padding" style={{ textAlign: "right" }}>
                                                                            <p><b className="text-secondary">Invoice Date :- </b> <b>{moment.utc(data.createddate).local().format('MM/DD/YYYY hh:mm A')} {moment.tz(moment.tz.guess()).zoneAbbr()}</b></p>
                                                                        </div>
                                                                    </div> */}
                                                                    <div className={`${this.state.windowWidth > 800 ? "d-flex flex-column-reverse" : ""}`} style={{ margin: "2% 5%" }}>
                                                                        { data.additionalnotes ? <p><b className="text-secondary" style={{paddingLeft: "15px"}}> Additional Notes </b>
                                                                        <OverlayTrigger className="no-print" trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{data.additionalnotes }</Tooltip>}>
                                                                            <i className={`fa fa-question-circle no-print`} style={{ fontSize: "14px" }}></i>
                                                                        </OverlayTrigger>
                                                                            <div className = {data.additionalnotes ? 'viewonlyinprint' : ''}>
                                                                                {data.additionalnotes}
                                                                            </div>
                                                                        </p> : ''}
                                                                        <div className="serviceview" >
                                                                            <div >
                                                                                {data.selectedService.length > 0 && <Table className="amountfields" responsive style={{ height: "100%" }}>
                                                                                    <thead>
                                                                                        <tr style={{ color: "#9F2241", flexWrap: "nowrap" }}>
                                                                                            <td>Services</td>
                                                                                            <td>Description</td>
                                                                                            <td style={{ textAlign: "right", paddingRight: "0px" }}>Amount</td>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {
                                                                                            data.selectedService.map((item, index) => (
                                                                                                <tr>
                                                                                                    <td>{item.name}</td>
                                                                                                    <td>{item.remark ? item.remark : "- - -"}</td>
                                                                                                    <td style={{ textAlign: "right", paddingRight: "0px" }}>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : '- - -'}</td>
                                                                                                </tr>
                                                                                            ))
                                                                                        }

                                                                                    </tbody>
                                                                                </Table>
                                                                                }
                                                                            </div>
                                                                            <Row className="" style={{paddingRight: "0px !important"}} >
                                                                                <Col></Col>
                                                                                <Col className="text-end text-secondary" ><b>Total Amount</b></Col>
                                                                                <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b>{data.invoiceamount ? `$ ${parseFloat(data.invoiceamount).toFixed(2)}` : '- - -'}</b></Col>
                                                                            </Row>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        <div className="serviceview">
                                            <Row className="">
                                                <Col></Col>
                                                <Col className="text-end text-secondary"><b>Total Amount</b></Col>
                                                <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "20px !important" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "15%" }}>{this.state.form.totalInvoiceAmount ? `$ ${parseFloat(this.state.form.totalInvoiceAmount).toFixed(2)}` : '- - -'}</b></Col>
                                            </Row>
                                            <Row className="">
                                                <Col></Col>
                                                <Col className="text-end text-secondary"><b>Payments Received </b></Col>
                                                <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "20px !important" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "15%" }}>{this.state.form.totalInvoiceAmountPaid ? `$ ${parseFloat(this.state.form.totalInvoiceAmountPaid).toFixed(2)}` : '- - -'}</b></Col>
                                            </Row>
                                            <Row className="">
                                                <Col></Col>
                                                <Col className="text-end text-secondary"><b>Remaining Amount Due </b></Col>
                                                <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "20px !important" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "15%" }}>{this.state.form.totalInvoicePendingAmount ? `$ ${parseFloat(this.state.form.totalInvoicePendingAmount).toFixed(2)}` : '- - -'}</b></Col>
                                            </Row>
                                        </div>
                                        <div className={`d-flex flex-column pe-5 invoice-message-wraper ${this.state.windowWidth > 1800 ? 'my-5' : 'my-4'}`} style={{ paddingLeft: "4%", textAlign: "justify" }} dangerouslySetInnerHTML={{ __html: this.state.form.invoicemessage }}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : <div className="d-flex flex-row justify-content-center text-center h-100">
                                 <h5 className="d-flex flex-row justify-content-center text-center align-items-center">Sorry, the given invoice number does not exist. Please select another invoice from the Invoices list.</h5>
                            </div>
                }
                <Modal id="transactionModal" show={this.state.transactionModal} centered onHide={() => this.setState({ transactionModal: false })}>
                    <Modal.Header closeButton>
                        <h5 className="text-secondary">Transaction History</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <Table responsive className="p-3">
                            <tbody>
                                <tr className="px-3 header">
                                    <td>Ctbids Transaction Id</td>
                                    <td>Date</td>
                                    <td>Transaction Type</td>
                                    <td>Payment Mode</td>
                                    <td>PayPal Status</td>
                                    <td>Amount</td>
                                    <td>Notes</td>
                                    <td>Response Code</td>
                                </tr>
                                {this.state.transactionData.length ?
                                    this.state.transactionData.map(data =>
                                        <tr className="px-3">
                                            <td>{data.referencenumber ? data.referencenumber : '- - -'}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{data.createddate ?`${moment.utc(data.createddate).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}` : '- - -'}</td>
                                            <td>{data.credit ? 'Credit' : 'Debit'}</td>
                                            <td>{data.paymentmode ? data.paymentmode : '- - -'}</td>
                                            <td>{data.paypalstatus ? data.paypalstatus.toLowerCase() : data.status ? data.status.toLowerCase() : '- - -' }</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{data.amount ? `$ ${data.amount.toFixed(2)}` : '- - -'}</td>
                                            <td>{data.comments ? data.comments : 'Manual Payment'}</td>
                                            <td>{data.tranresponse ? 
                                                <div>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{this.getTransactionMessage(data.tranresponse)}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div> : '- - -' }
                                            </td>
                                        </tr>
                                    ) :
                                    <tr><td colSpan="6"><h5 className="noData" >No Data Found</h5></td></tr>
                                }
                            </tbody>
                        </Table>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.bidderAcceptanceModal} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="body-content">
                            <div className="align-items-ccenter justify-content-between">
                                {this.state.bidderAcceptanceData == 'Accepted' ? 
                                    <div className='text-center' style={{padding: '10px'}}>
                                      { this.state.confirmApprove ?  <span style={{color: 'green'}}>Congratulations! You have Approved the Additional Services.</span> : "Please confirm to approve Additional Services." }
                                    </div> : 
                                    <div className='text-center' style={{padding: '10px'}}>
                                       Please confirm to decline the Additional services. Please reach out to seller to discuss any additional options.
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center mt-4 actions">
                            <Button variant="outline-dark btn-white mx-2" onClick={() => this.closeConfirmModal()}>Cancel</Button>
                            <Button disabled={this.state.confirmApprove} variant="secondary mx-2" onClick={() => this.bidderAcceptance(this.state.bidderAcceptanceData, this.state.bidderAcceptanceAddOn)}>Confirm {this.state.checkapprove ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null} </Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default connect(state => state)(InvoiceView);